import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/SiteManagement/Form/PotentialVariationOrderIndexRegisterForm/index'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import {
    v2_ships,
} from '../../../actions/v2/projectAndVessel';
import { v3_fetchNewBuildingSiteAuditIndex, v3_fetchPotentialVariationOrderIndexRegisterForm, v3_submitNewBuildingSiteAuditIndex, v3_submitPotentialVariationOrderIndexRegisterForm } from '../../../actions/v3/siteManagement';
import { v2_submitted_potential_variable_order_form } from '../../../actions/v2/siteManagement';

const NewBuildingBlockInspectionStatus = (props) => {

    const location = useLocation();
    const { data } = location.state || {};
    // 1. Rename state to items (flat list)

    const defaultRow = {
        date_audited: { name: 'date_audited', value: '', error: '', isRequired: true },
        form: { name: 'form', value: '', error: '', options: [], isRequired: true },
        estimated_cost: { name: 'estimated_cost', value: '', options: [], error: '', isRequired: true },
        approved_date: { name: 'approved_date', value: '', error: '', isRequired: true },
        agreed_date: { name: 'agreed_date', value: '', error: '', isRequired: true },
        agreed_cost: { name: 'agreed_cost', value: '', error: '', isRequired: true },
        time_impact: { name: 'time_impact', value: '', error: '', isRequired: true },
        remarks: { name: 'remarks', value: '', error: '', isRequired: false },


    };

    const [state, setState] = useState([defaultRow]);
    const handleChange = (field, value, index = 0) => {
        setState(prevState => {
            const updatedState = [...prevState];
            updatedState[index][field] = {
                ...updatedState[index][field],
                value,
                error: '',
            };
            return updatedState;
        });
    };

    const addRow = () => {
        setState(prev => {
            const formOptions = prev[0]?.form?.options || [];
            const newRow = {
                ...JSON.parse(JSON.stringify(defaultRow)),
                form: { ...defaultRow.form, options: formOptions }
            };
            return [...prev, newRow];
        });
    };
    


    useEffect(()=>{

    },[])
    const removeRow = (indexToRemove) => {
        setState(prev => prev.filter((_, i) => i !== indexToRemove));
    };


    const [showLoader, setShowLoader] = useState(false);

// Load ships when yard changes
    useEffect(() => {
        v2_submitted_potential_variable_order_form().then((res) => {
            if (res.status) {

                setState((prevState) =>
                    prevState.map((row) => ({
                        ...row,
                        form: {
                            ...row.form,
                            options: res.result,
                        },
                    }))
                );
            }
        });
    }, []);

    useEffect(() => {
        setShowLoader(true);

        v3_fetchPotentialVariationOrderIndexRegisterForm(
        )
            .then((res) => {
                if (res.status) {
                    
                    // convert flat records to form model
                    const mappedItems = res.result.map((item) => {
                        return {
                            entryId: item.ID,
                            date_audited: {
                                ...defaultRow.date_audited,
                                value: item.DATE_AUDITED || '',
                            },
                            form: {
                                ...defaultRow.form,
                                value: item.POTENTIAL_VARIATION_ORDER_ID || '',
                            },
                            estimated_cost: {
                                ...defaultRow.estimated_cost,
                                value: item.ESTIMATED_COST_IN_USD,
                            },
                            approved_date: {
                                ...defaultRow.approved_date,
                                value: item.APPROVED_DATE,
                            },agreed_date: {
                                ...defaultRow.agreed_date,
                                value: item.AGREED_DATE,
                            },agreed_cost: {
                                ...defaultRow.agreed_cost,
                                value: item.AGREED_COST_IN_USD,
                            },time_impact: {
                                ...defaultRow.time_impact,
                                value: item.TIME_IMPACT_IN_DAYS,
                            },
                            remarks: {
                                ...defaultRow.remarks,
                                value: item.REMARKS,
                            },
 
                        };
                    });
                    // set state (renamed from state to items if needed)
                    setState(mappedItems);
                } else {
                    toast.error(res.error);
                }
            })
            .catch(() => toast.error('Something went wrong while fetching.'))
            .finally(() => setShowLoader(false));

    }, []);

    const onSubmit = async () => {
        // 1. Validation
        const errors = [];

        // Validate each row
        state.forEach((row, index) => {
            Object.entries(row).forEach(([key, field]) => {
                if (key === 'entryId') return; // Skip entryId

                const isRequired = field.isRequired  // Enforce all fields if finalSubmit is true
                if (isRequired && !field.value) {
                    errors.push(`Row ${index + 1}: ${key.replace(/_/g, ' ')} is required.`);
                }
            });
        });


        if (errors.length > 0) {
            toast.error(errors.join('\n'));
            return;
        }
        // If final submit is true, confirm before proceeding



        // 2. Build checklistItems payload
        const checklistItems = state.map((row) => {
            const formattedRow = {};
            Object.keys(row).forEach((key) => {
                formattedRow[key] = row[key].value;
            });
            if (row['entryId']) {
                formattedRow.ID = row['entryId']
            }
            return formattedRow;
        });

        // 3. Build full payload
        const payload = {
            checklistItems,
        };

        // 4. Submit
        setShowLoader(true);
        v3_submitPotentialVariationOrderIndexRegisterForm(payload)
            .then((res) => {
                setShowLoader(false);
                if (res.status) {
                    toast.success(res.result.message || 'Submitted successfully!');
                    props.history.push(constant.Authedcomponent.siteManagement.url);
                } else {
                    toast.error(res.error || 'Submission failed.');
                }
            })
            .catch((err) => {
                setShowLoader(false);
                toast.error('Submission failed.');
                console.error('Submit Error:', err);
            });
    };


    return (
        <Layout title="Site Query Report Index">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>(P) VO INDEX REGISTER
                                            </h4>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Form
                                onChange={handleChange}
                                state={state}
                                onSubmit={onSubmit}
                                addRow={addRow}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NewBuildingBlockInspectionStatus